import { useContext } from 'react';
import { MapControlContext } from '../contexts/mapcontrol.context';
import { checkEstimatesShouldDisplayConditions } from '../utils/utils';
import { EstimateType } from 'types/Estimate';
import { SearchFilterContext } from '../contexts/searchFilter.context';

export default function useFilteredAssets() {
  const { apiCallInProgress, showAssetsChecked } = useContext(MapControlContext);
  const { searchType } = useContext(SearchFilterContext);
  // a simple function to return all assets passed in, or empty array depending if a condition is not met.
  // note that this function depends on context being up to date. If this is used before a context is updated, it will not have correct values.
  function getVisibleAssets(assets: EstimateType[]) {
    const assetsShouldDisplay = checkEstimatesShouldDisplayConditions(
      [showAssetsChecked, true],
      [apiCallInProgress, false],
      [searchType !== 'users', true],
    );

    return assetsShouldDisplay ? assets : [];
  }

  return getVisibleAssets;
}
